import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AnimatePresence } from 'framer-motion';
import { I18nextProvider, useTranslation } from 'react-i18next'; // Fournisseur de traduction
import i18n from './i18n'; // Configuration i18next
import { useEffect } from 'react'; // Importer useEffect pour le préchargement des images
import theme from './theme';
import './App.css';

import Index from './views/Index';
import Flowers from './views/Flowers';
import About from './views/About';
import FrescoZoom from './views/FrescoZoom';
import Line from './views/Line';
import Link from './views/Link';

import Artwork from './views/Artwork'; 
import { Helmet } from 'react-helmet'; // Importer Helmet pour gérer les balises <meta>

function AppWithAnimatePresence() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Index />} />
        <Route path="/link" element={<Link />} />
        <Route path="/flowers" element={<Flowers />} />
        <Route path="/line" element={<Line />} />
        <Route path="/artwork/:id" element={<Artwork />} />
        <Route path="/about" element={<About />} />
        {/* Zoom profond par tuiles : remplace les JPEG de 14,5 et 16,7 Mo. */}
        <Route path="/littlemermaid" element={<FrescoZoom fresco="littlemermaid" />} />
        <Route path="/imieiamori" element={<FrescoZoom fresco="imieiamori" />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  const { t } = useTranslation(); // Utiliser la traduction dans le composant principal

  // Fonction pour précharger les images
  useEffect(() => {
    const preloadImages = async () => {
      try {
        const response = await fetch('/data/flowers.json'); // Charger le fichier flowers.json
        const data = await response.json();

        data.forEach(artwork => {
          // Précharger l'image principale
          const mainImg = new Image();
          mainImg.src = `/assets/images/${artwork.mainImage}`;

          // Précharger les images secondaires (absentes de la plupart des œuvres)
          (artwork.secondaryImages || []).forEach(image => {
            const secImg = new Image();
            secImg.src = `/assets/images/${image}`;
          });
        });
      } catch (error) {
        console.error("Erreur lors du préchargement des images :", error);
      }
    };

    preloadImages(); // Appeler la fonction pour précharger les images
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <Router>
          <Helmet>
            <title>KAJIKA AKI</title>
            <meta name="description" content={t('meta.description')} />
          </Helmet>
          <AppWithAnimatePresence />
        </Router>
      </I18nextProvider>
    </ThemeProvider>
  );
}

export default App;